import React from 'react';
import PropTypes from 'prop-types';

const IconPowertrainGuideSend = ({ width = 16, height = 16, color = '#FFFFFF' }) =>
    <svg width={width} height={height} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M14 6.5L8.5 1L3 6.5L4.5 8L7.5 5V15H9.5V5L12.5 8L14 6.5Z' fill={color} />
    </svg>;

IconPowertrainGuideSend.propTypes = {
    color: PropTypes.string,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default IconPowertrainGuideSend;
